import React, { useState } from 'react';
import {
  StyledCircle,
  StyledInput,
  StyledRadioButtonTitle,
  StyledRadioButtonWrapper
} from './style';
import { OptionType, RadioGroupType } from '../../../Types/common.type';
import { StyledDiv, StyledSpan } from '../../../Theme/CommonStyled';
import Icon from '../Icon';

const RadioGroup: React.FC<RadioGroupType> = ({
  options,
  onChange,
  layout,
  disabled,
  defaultCheckedRadio
}) => {
  const [checkedValue, setCheckedValue] = useState(defaultCheckedRadio);

  const toggleRadioHandler = (value: OptionType) => {
    setCheckedValue(value);
    onChange(value);
  };

  return (
    <>
      {options.map((item) => (
        <StyledRadioButtonWrapper
          disabled={disabled}
          layout={layout}
          key={String(item.value)}>
          <StyledCircle
            checked={checkedValue.value === item.value}
            disabled={disabled}
          />
          <StyledInput
            disabled={disabled}
            type={'radio'}
            checked={item.value === checkedValue.value}
            onChange={() => toggleRadioHandler(item)}
          />
          <StyledRadioButtonTitle disabled={disabled}>
            <StyledDiv display="flex" flexDirection="column">
              <StyledDiv mb={4}>
                {item.description && item.value !== 0 && (
                  <Icon name="store" ml={5} color="normalText" fontSize={18} />
                )}
                {item.label}
              </StyledDiv>
              {item.description && (
                <StyledSpan color="minorText" fontSize={2}>
                  {item.description}
                </StyledSpan>
              )}
            </StyledDiv>
          </StyledRadioButtonTitle>
        </StyledRadioButtonWrapper>
      ))}
    </>
  );
};

export default RadioGroup;
